export const environment = {
  production: true,
  version: "v 1.5.1",
  versionCheckURL: "https://get-flipped.app/version.json",
  appInsights: {
    connectionString:
      "InstrumentationKey=950a4ce1-2535-4ce8-9224-822670501faf;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/;ApplicationId=b68941a2-2384-4517-8f61-09ffbec3471f",
  },
  apiBaseUrl: "https://api.get-flipped.app",
  communityForumUrl: "https://community.get-flipped.app",
  // Controls the "Create one" register link on the login page in the browser.
  // The mobile app shows it regardless of this flag.
  showWebRegisterLink: true, // FLIP-541: browser sign-up allowed in production again (pays through Stripe)
  vapidPublicKey:
    "BHxptOW1_AdAYI_MQXL9mefAwgxQDvLR9zSM60QutBK85n2BuVqHFtcyHo1DhP1qT6lMmIs80nWJSHT3K3eBEBI",
};
